import FormControl from "@mui/material/FormControl/FormControl";
import TextField from "@mui/material/TextField";
import React, { Fragment } from "react";
import SegmentSelectBox from "../SegmentSelectBox";
import OperandSelectBox from "../OperandSelectBox";

export default function BigCommerceCartValueCondition({ condition, onChange, placeholder }) {
    const operands =
        [
            { "value": "is", "label": "is" },
            { "value": "is_not", "label": "is not" },
            { "value": "less_than", "label": "is less than" },
            { "value": "greater_than", "label": "is greater than" },
            { "value": "between", "label": "is between" }
        ];

    if (!condition.operand) {
        onChange({ target: { name: 'operand', value: 'is' } });
    }

    const updateBetween = (index, value) => {
        const newValue = Array.isArray(condition.value) ? [...condition.value] : [condition.value || '', ''];
        newValue[index] = value;
        onChange({ target: { name: 'value', value: newValue } });
    };

    const isBetween = condition.operand === 'between';

    return (
        <div className="condition-ruleset">
            <SegmentSelectBox value={condition.segment} onChange={onChange} />
            <OperandSelectBox operands={operands} value={condition.operand} onChange={onChange} />

            {isBetween ? (
                <Fragment>
                    <FormControl variant="outlined">
                        <TextField
                            size="small"
                            type="number"
                            name="value"
                            placeholder="min"
                            onChange={(e) => updateBetween(0, e.target.value)}
                            value={Array.isArray(condition.value) ? condition.value[0] : condition.value}
                            variant="outlined"
                            InputProps={{ inputProps: { min: 0 } }}
                            style={{ width: '100px' }}
                        />
                    </FormControl>
                    <span style={{ margin: '0 8px', alignSelf: 'center' }}>and</span>
                    <FormControl variant="outlined">
                        <TextField
                            size="small"
                            type="number"
                            name="value"
                            placeholder="max"
                            onChange={(e) => updateBetween(1, e.target.value)}
                            value={Array.isArray(condition.value) ? condition.value[1] : ''}
                            variant="outlined"
                            InputProps={{ inputProps: { min: 0 } }}
                            style={{ width: '100px' }}
                        />
                    </FormControl>
                </Fragment>
            ) : (
                <FormControl variant="outlined">
                    <TextField
                        size="small"
                        type="number"
                        name="value"
                        placeholder={placeholder}
                        onChange={onChange}
                        value={Array.isArray(condition.value) ? condition.value[0] : condition.value}
                        variant="outlined"
                        InputProps={{ inputProps: { min: 0 } }}
                    />
                </FormControl>
            )}
        </div>
    );
}
